import * as React from 'react';
/**
 * @ignore - internal component.
 */
var ToggleButtonGroupButtonContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ToggleButtonGroupButtonContext.displayName = 'ToggleButtonGroupButtonContext';
}
export default ToggleButtonGroupButtonContext;